import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f17cb8c")

_pushScopeId("data-v-3f17cb8c")
const _hoisted_1 = {
  key: 0,
  class: "min-height45px m-top-md"
}
const _hoisted_2 = { class: "choose-tag-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_6 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_choose_tag = _resolveComponent("choose-tag")
  const _component_list = _resolveComponent("list")
  const _component_customize_pagination = _resolveComponent("customize-pagination")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.showChooseTitle)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextSelected) + " ", 1),
            (_ctx.showLength)
              ? (_openBlock(), _createBlock("b", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.selectedItemInTag.length) + " ", 1),
                  (_ctx.chooseTitleType==='total')
                    ? (_openBlock(), _createBlock("b", _hoisted_4, "/ " + _toDisplayString(_ctx.totalNumber), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _hoisted_5
          ]),
          (_ctx.chooseTitleType!=='total')
            ? (_openBlock(), _createBlock("span", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.choose, (item, index) => {
                  return (_openBlock(), _createBlock(_component_choose_tag, {
                    key: index,
                    onRemove: ($event: any) => (_ctx.remove(item))
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.chooseLabelDeal(item)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: _ctx.listType === 'pagination' || _ctx.isOpenVirtual ? '' : 'access-group-list'
    }, [
      _createVNode(_component_list, {
        class: _ctx.listType === 'pagination' && !_ctx.isOpenVirtual ? 'access-group-list' : '',
        headers: _ctx.headers,
        listData: _ctx.listData,
        requestData: _ctx.requestDataWithPage,
        action: _ctx.action,
        showCheck: _ctx.showCheck,
        selectedItem: _ctx.selectedItemInTag,
        keyOfCheck: _ctx.keyOfCheck,
        update: _ctx.update + _ctx.updateWithRow,
        deleteUrl: _ctx.deleteUrl,
        dealList: _ctx.dealList,
        deleteMessage: _ctx.deleteMessage,
        "is-clear-check": _ctx.isClearCheck,
        showDefaultAction: _ctx.showDefaultAction,
        onActionEmit: _ctx.actionEmit,
        onMultipleSelect: _ctx.multipleSelect,
        onGetTotal: _ctx.getTotal
      }, _createSlots({ _: 2 }, [
        _renderList(_ctx.headers, (header, headerIndex) => {
          return {
            name: _ctx.getSlotName(header.name),
            fn: _withId((data) => [
              (header.type === 'customize')
                ? _renderSlot(_ctx.$slots, _ctx.getSlotName(header.name), {
                    key: 0,
                    scope: data.scope
                  })
                : _createCommentVNode("", true)
            ])
          }
        }),
        _renderList(_ctx.headers, (header, headerIndex) => {
          return {
            name: `${_ctx.getSlotName(header.name)}Header`,
            fn: _withId((data) => [
              (header.headerType === 'customize')
                ? _renderSlot(_ctx.$slots, `${_ctx.getSlotName(header.name)}Header`, {
                    key: 0,
                    scope: data.scope
                  })
                : _createCommentVNode("", true)
            ])
          }
        })
      ]), 1032, ["class", "headers", "listData", "requestData", "action", "showCheck", "selectedItem", "keyOfCheck", "update", "deleteUrl", "dealList", "deleteMessage", "is-clear-check", "showDefaultAction", "onActionEmit", "onMultipleSelect", "onGetTotal"]),
      (_ctx.listType === 'pagination')
        ? (_openBlock(), _createBlock(_component_customize_pagination, {
            key: 0,
            initRow: _ctx.row,
            initPage: _ctx.pageNumber,
            rowOptions: [],
            total: _ctx.totalNumber,
            reset: 0,
            onSearch: _ctx.serch
          }, null, 8, ["initRow", "initPage", "total", "onSearch"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
})